export const INTRO_STAGE = 0
export const START_STAGE = 1
export const LOCATION_SELECT = 2;
export const SHOW_REWARDS = 5;
export const CORRECT_LOCATION = 6
export const INCORRECT_LOCATION = 7
export const SELECT_INTEREST = 3;
export const SHOW_EVENTS = 4
export const LOADING = 8;
